import { createFileRoute, Link } from '@tanstack/react-router';

import { NotificationsScreen } from '../../features/notifications/notifications-screen';
import { NotificationsTabs } from '../../features/notifications/notifications-tabs';
import { NOTIFICATION_PERMISSIONS } from '../../features/notifications/types';
import { RequirePermission } from '../../lib/session/guards';

export const Route = createFileRoute('/notifications/')({
  component: NotificationsPage,
});

/**
 * `/notifications` — the delivery log (MASTER_PLAN M9.8, FR-ADMIN-08, FR-NOTIF-06).
 *
 * `notifications.read` opens it, and `clinic_staff` holds that key: "did the confirmation
 * reach them?" is a front-desk question, not an administrator's. Resending additionally
 * needs `notifications.resend`, which the screen checks for the button and the server
 * checks for the call (rules §17.2, §22.2).
 */
function NotificationsPage() {
  return (
    <RequirePermission keys={[NOTIFICATION_PERMISSIONS.read]}>
      <NotificationsScreen
        renderTabs={() => (
          <NotificationsTabs
            active="log"
            renderLink={(to, children, props) => (
              <Link to={to} className={props.className} aria-current={props['aria-current']}>
                {children}
              </Link>
            )}
          />
        )}
      />
    </RequirePermission>
  );
}
